import store from "@frameworks/web/redux/store";
import { CLIENT_GEN_OTP, CLIENT_GEN_OTP_ERROR, CLIENT_GEN_OTP_HIDE_ERROR, CLIENT_GEN_OTP_START_LOADER, CLIENT_GEN_OTP_STOP_LOADER, } from "../interface/IClientGenOTP";
class ClientGenOTPActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    ClientGenOTP(data) {
        this.dispatch({
            type: CLIENT_GEN_OTP,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: CLIENT_GEN_OTP_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: CLIENT_GEN_OTP_HIDE_ERROR,
        });
    }
    loader() {
        this.dispatch({
            type: CLIENT_GEN_OTP_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: CLIENT_GEN_OTP_STOP_LOADER,
        });
    }
}
export default ClientGenOTPActions;
